<script setup lang="ts">
import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import { Initiative } from "@/model";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";

const initiatives = await pb.collection('initiatives').getFullList<Initiative>(null, {
  sort: '-startDate',
});
</script>

<template>
  <Title>Initiatives</Title>

  <Divider/>
  <Content>
    <p>
      Overview of group-wide initiatives and special interest groups (SIG).
    </p>

    <div class="grid lg:grid-cols-3 gap-2 lg:gap-5">
      <LinkBox v-for="initiative in initiatives" route="initiative" :routeParams="{ slug: initiative.slug }" :title="initiative.name" :description="initiative.abstract"/>
    </div>
  </Content>
</template>

